<template>
  <action-invites
    ref="actionInvites"
    :participants="participants"
    :selected-participants="selectedParticipants"
    :api="getApiForInvite"
  />
</template>

<script>
import { mapState } from 'vuex';

import ActionInvites from '@/components/rooms/actions/ActionInvites.vue';
import { on, trigger } from '@/lib/events';

export default {
  name: 'RoomAssignmentInvite',
  components: {
    ActionInvites,
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    participants: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
    selectedParticipants() {
      return this.selected
        .map((id) => this.participants.find(({ identity }) => identity === id))
        .filter(Boolean);
    },
    getApiForInvite() {
      return {
        on,
        trigger,
        disconnect: () => {},
        send: (action) => {
          action.from = {
            identity: this.roomInfo.identity,
            name: this.roomInfo.name,
            room: this.roomInfo.room,
            roomName: this.roomInfo.room_name,
          };
          action.type = 'ActionInvites';

          this.$emit('sendActionToParticipant', {
            action,
            to: action.to,
          });
        },

        updateParticipantInfo: (data) => {
          this.$emit('sendActionToParticipant', {
            info: {
              ...data,
              identity: data.identity,
            },
            to: {
              identity: data.identity,
            },
          });
        },
      };
    },
  },
  methods: {
    openInviteModal() {
      this.$refs.actionInvites.selected();
    },
  },
};
</script>
